// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"arrow-up"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M17.5 10.5L12 5L6.5 10.5M12 6.25V19.25","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ArrowUpIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'arrow-up',
    ref,
    icon: element,
  },
));

ArrowUpIcon.displayName = 'ArrowUpIcon';

export default ArrowUpIcon;
